<template>
  <v-dialog
    v-if="solicitud"
    v-model="active"
    width="480"
    persistent
  >
    <v-card color="primary">
      <v-card-title>Información extra</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-caption">
                Descripción
              </div>
              <div class="text-body-2 font-weight-bold">
                {{ solicitud.descripcion }}
              </div>
            </v-col>
            <v-col cols="12">
              <div class="text-caption">
                Información extra
              </div>
              <div class="text-body-2 font-weight-bold">
                {{ solicitud.informacionExtra }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          text
          color="secondary"
          @click="closeDialog()"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
    },

    solicitud: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
